import { render, staticRenderFns } from "./nutritionDashboard.vue?vue&type=template&id=ee0ebdc8"
import script from "./nutritionDashboard.vue?vue&type=script&lang=js"
export * from "./nutritionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports